
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/assistantrobo",
      function () {
        return require("private-next-pages/cases/assistantrobo/index.tsx");
      }
    ]);
  